export default "__VITE_ASSET__c5MllD5X__"